// /workspace-feature
import React from 'react';
import { faBolt, faFolderOpen, faUpload } from '@fortawesome/free-solid-svg-icons';
import ProductPage from './ProductPage';
import berkeley_campus from '../../assets/images/unauth/berkeley-school-campus.jpg';
import workspace_header from '../../assets/images/unauth/workspace-feature-header.jpg';
import workspace_chat from '../../assets/images/unauth/workspace-feature-chat.jpg';
import workspace_timestamps from '../../assets/images/unauth/workspace-feature-timestamps.jpg';
import workspace_poster from '../../assets/images/unauth/workspace-feature-poster.jpg';

const WorkspaceFeature = () => (
  <ProductPage
    path="/workspace-feature"
    seo={{
      title: 'AI Video Management with Workspaces | Bumpups.com',
      description: 'Effortlessly manage and analyze your video content with Bumpups Workspaces. Upload, organize, and interact with your videos using our AI-powered platform for accessible insights and streamlined workflows.',
    }}
    hero={{
      title: 'Video management with Workspaces',
      subtitle: 'Upload, organize, and interact with your video content, whether from YouTube or local files.',
      image: workspace_header,
      imageAlt: 'Your workspaces in Bumpups: one per video, with its thumbnail and length',
      width: 1200,
      height: 1192,
    }}
    benefits={{
      title: 'Make video analysis simple',
      items: [
        { icon: faUpload, title: 'Effortless uploads', text: 'Import videos with ease using YouTube links or local files—start analyzing within minutes.' },
        { icon: faFolderOpen, title: 'Streamlined organization', text: 'Categorize and manage your video library efficiently, making search and retrieval a breeze.' },
        { icon: faBolt, title: 'Instant AI insights', text: 'Leverage our AI to generate detailed analytics, summaries, and actionable insights from your videos.' },
      ],
    }}
    workflow={{
      title: 'Automate your video management workflows',
      description: 'Import, analyze, and organize your video content—powered by our advanced AI engine.',
      video: '/media/workspace-feature.mp4',
      poster: workspace_poster,
      features: [
        { title: 'Easy upload', text: 'Import videos via YouTube links or local files for immediate processing.' },
        { title: 'Chat with your video', text: 'Ask questions, request summaries, analyses, and more, then follow up. Bump AI remembers the conversation.' },
        { title: 'Automatic timestamps', text: 'Every video gets AI-generated timestamps, ready to copy into YouTube.' },
      ],
    }}
    rows={[
      {
        title: 'Chat with any video',
        text: 'Ask about a lecture, podcast, or meeting and get answers grounded in what was said and shown. Follow up to go deeper, shorten an answer, or turn it into notes, posts, or quizzes.',
        cta: 'Start chatting',
        image: workspace_chat,
        alt: 'A workspace chat answering which three stories Steve Jobs tells in his Stanford commencement speech',
      },
      {
        title: 'Timestamps, generated for you',
        text: 'Bump AI chapters every video you add, with specific titles for each moment, so you can find your way around a long video or paste the chapters straight into YouTube.',
        cta: 'Try it out',
        image: workspace_timestamps,
        alt: 'A Harvard lecture in a workspace, with its AI-generated timestamps',
      },
    ]}
    caseStudy={{
      title: 'Workspaces for education',
      text: 'Students and educators harness AI-powered video management to streamline lectures, ask questions, access info, and create practice tests and quizzes.',
      image: berkeley_campus,
      imageAlt: 'University campus',
      stats: [
        { value: 'Up to 3.5 hours', label: 'Optimized for extended-length videos' },
        { value: 'AI-powered', label: 'Enhanced insights generation' },
        { value: '10K+', label: 'Videos processed' },
      ],
    }}
  />
);

export default WorkspaceFeature;
